module.exports = __webpack_public_path__ + "static/car-pc/img/play.47353939.svg";